// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { WorkOSProvider } from './features/workos/context/WorkOSContext';
import App from './App.jsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <WorkOSProvider>
        <App />
      </WorkOSProvider>
    </HelmetProvider>
  </React.StrictMode>
);